exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-select-products {\r\n\twidth: 100%;\r\n\tborder: 1px solid rgba(0,0,0,.15);\r\n    border-radius: .25rem;\r\n    height: 100%;\r\n}\r\n\r\n.custom-select-products option:first-child {\r\n\tborder-top-left-radius: 8px;\r\n    border-top-right-radius: 8px;\r\n    border-top: none;\r\n}\r\n\r\n.custom-select-products option {\r\n\tborder-top: thin solid #ddd;\r\n    border-bottom: 1px solid #ddd;\r\n    display: block;\r\n    padding: 6px 6px 6px 14px;\r\n    margin-bottom: -1px;\r\n    font-size: 0.85em;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    min-height: 16px;\r\n    font-weight: inherit;\r\n    font-size: 14px;\r\n    color: #545454;\r\n}\r\n\r\n.custom-select-products option:hover {\r\n\tbackground-color: #f5f5f5;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reportConfiguration/edit.report.configuration.component.css
// module id = ../../../../../src/app/private/reportConfiguration/edit.report.configuration.component.css
// module chunks = main